module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8jcQc"))).then(() => parcelRequire('d0iPb'));